import * as analytics from '@gitbook/app-analytics/client';
import { Icon } from '@gitbook/spine-icons';
import { Button, DialogRoot, useDialogTriggerState } from '@gitbook/spine-react';

import { ImportInSpaceDialog, TemplateDialog } from '../../../Components';
import { useNavigation } from '../../../navigation';
import { useSpaceContext } from '../context';

/**
 * Blank state for a space to prompt to use a template or import some content
 */
export function SpaceBlankSlate() {
    const { navigate } = useNavigation();
    const { space, analyticsContext } = useSpaceContext();
    const importDialog = useDialogTriggerState();
    const templateDialog = useDialogTriggerState();

    return (
        <>
            <DialogRoot {...importDialog.rootProps}>
                <ImportInSpaceDialog />
            </DialogRoot>

            <DialogRoot {...templateDialog.rootProps}>
                <TemplateDialog
                    organizationId={space.organization}
                    space={space}
                    onComplete={(space) => {
                        navigate({
                            screen: {
                                type: 'space',
                                space: space.id,
                                organization: space.organization,
                                page: '',
                            },
                            overlay: null,
                        });
                    }}
                />
            </DialogRoot>

            <div className="my-4 flex flex-wrap gap-1 rounded-md border p-2">
                <Button
                    leadingIcon={<Icon.Download className="text-primary" />}
                    kind="blank"
                    size="medium"
                    onPress={() => {
                        importDialog.setOpen(true);
                        analytics.logEvent({
                            ...analyticsContext,
                            type: 'space_blank_slate_initiate',
                            kind: 'import',
                        });
                    }}
                    label="Import content"
                />

                <Button
                    leadingIcon={<Icon.Page className="text-primary" />}
                    kind="blank"
                    size="medium"
                    onPress={() => {
                        templateDialog.setOpen(true);

                        analytics.logEvent({
                            ...analyticsContext,
                            type: 'space_blank_slate_initiate',
                            kind: 'template',
                        });
                    }}
                    label="Use a template"
                />

                <Button
                    leadingIcon={<Icon.GitHub className="text-primary" />}
                    kind="blank"
                    size="medium"
                    onPress={() => {
                        navigate({
                            current: { sideSheet: { type: 'gitsync-setup' } },
                        });
                        analytics.logEvent({
                            ...analyticsContext,
                            type: 'space_blank_slate_initiate',
                            kind: 'gitsync',
                        });
                    }}
                    label="Set up Git Sync"
                />
                <Button
                    leadingIcon={<Icon.User className="text-primary" />}
                    kind="blank"
                    size="medium"
                    onPress={() => {
                        navigate({ screen: { sideSheet: { type: 'share', tab: 'invite' } } });
                        analytics.logEvent({
                            ...analyticsContext,
                            type: 'space_blank_slate_initiate',
                            kind: 'invite-members',
                        });
                    }}
                    label="Add members"
                />
            </div>
        </>
    );
}
